import React from "react";
import Header from "./components/Header";
import Home from "./components/Home";

import { HashRouter as Router, Switch, Route } from "react-router-dom";

const App = () => (
  <div>
    <Header />
    <Router>
      <Switch>
        <Route exact path="/">
          <Home />
        </Route>
      </Switch>
    </Router>
  </div>
);

export default App;
